<as-split useTransition="true" (dragEnd)="dragEnd($event)" [direction]="direction" gutterSize="30"
    [disabled]="isLocked">
    <ng-container *ngFor="let area of areas; let i = index" >

        <as-split-area [size]="area.size" [minSize]="area.minSize"
            [maxSize]="area.maxSize">
            <div class="custom-collapse-gutter" asSplitGutterExcludeFromDrag *ngIf="i > 0" 
                    [class]="direction === 'horizontal' ? 'move-buttons-horizontal' : 'move-buttons-vertical'">
                    <div (click)="collapseArea(i, 'after')">
                        <button mat-icon-button>
                           <mat-icon>{{direction === 'horizontal' ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}}
                            </mat-icon>
                        </button>
                    </div>
                    <div (click)="collapseArea(i - 1, 'before')">
                        <button mat-icon-button>
                            <!-- <mat-icon class="icon-size-4" 
                            [svgIcon]="direction === 'horizontal' ? 'keyboard_arrow_left' : 'keyboard_arrow_up'">
                            </mat-icon> -->
                            <mat-icon>{{direction === 'horizontal' ? 'keyboard_arrow_left' : 'keyboard_arrow_up'}}
                            </mat-icon>
                        </button>
                    </div>
                </div>
            <ng-container *ngTemplateOutlet="templates.toArray()[i]"></ng-container>
        </as-split-area>
        
    </ng-container>

</as-split>